import { createStore } from "vuex";
import { getFunctions, httpsCallable } from "firebase/functions";
import {
  collection,
  query,
  getDocs,
  orderBy,
  doc,
  addDoc,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "@/firebase";
import { deleteImageByUrl } from "@/utils/storage";

export default createStore({
  state: {
    drawer: false,
    nieuws: [],
    nieuwsbrieven: [],
    admin_nieuws: [],
    user: null,
    donaties: [],
    saving: false,
    reviews: [],
  },
  getters: {},
  mutations: {
    setDrawer(state, val) {
      state.drawer = val;
    },
    setNieuws(state, val) {
      state.nieuws = val;
    },
    setUser(state, val) {
      state.user = val;
    },
    setSaving(state, val) {
      state.saving = val;
    },
    setAdminNieuws(state, val) {
      state.admin_nieuws = val;
    },
    setNieuwsbrieven(state, val) {
      state.nieuwsbrieven = val;
    },
    setDonaties(state, val) {
      state.donaties = val;
    },
    setReviews(state, val) {
      state.reviews = val;
    },
  },
  actions: {
    async getNieuws({ commit, state }) {
      let articles = [];
      let admin = [];
      const q = query(collection(db, "nieuws"), orderBy("timestamp", "desc"));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        if (doc.data().public) {
          articles.push(doc.data());
        }
        if (state.user) {
          admin.push(doc.data());
        }
      });

      commit("setNieuws", articles);
      commit("setAdminNieuws", admin);
    },
    async getNieuwsbrieven({ commit, state }) {
      if (state.user) {
        let signups = [];

        const q = query(collection(db, "nieuwsbrief"), orderBy("date", "desc"));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          signups.push(doc.data());
        });
        console.log(signups);

        commit("setNieuwsbrieven", signups);
      }
    },
    async getDonaties({ commit, state }) {
      if (state.user) {
        let donaties = [];

        const q = query(collection(db, "donaties"), orderBy("date", "desc"));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          donaties.push(doc.data());
        });
        console.log(donaties);

        commit("setDonaties", donaties);
      }
    },
    async getReviews({ commit }) {
      console.log("getReviews");
      let reviews = [];
      const q = query(collection(db, "reviews"), orderBy("timestamp", "desc"));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        console.log(doc.data());
        reviews.push(doc.data());
      });
      commit("setReviews", reviews);
    },
    async addReview({ dispatch }, review) {
      await addDoc(collection(db, "reviews"), review);
      dispatch("getReviews");
    },
    async deleteReview({ dispatch }, uid) {
      let r = confirm("Weet je het zeker?");
      if (r) {
        await deleteDoc(doc(db, "reviews", uid));
        dispatch("getReviews");
      }
    },
    async removeNieuwsbrief({ dispatch }, uid) {
      let r = confirm("Weet je het zeker?");
      if (r) {
        await deleteDoc(doc(db, "nieuwsbrief", uid));
        dispatch("getNieuwsbrieven");
      }
    },
    async updateReview({ dispatch }, review) {
      if (!review.uid) {
        const docRef = await addDoc(collection(db, "reviews"), review);
        review.uid = docRef.id;
        await updateDoc(doc(db, "reviews", docRef.id), {
          uid: docRef.id,
        });
      } else {
        await updateDoc(doc(db, "reviews", review.uid), {
          review: review.review,
          name: review.name,
          rating: review.rating,
        });
      }
      dispatch("getReviews");
    },
    async updateArticle({ commit, dispatch }, val) {
      commit("setSaving", true);
      const functions = getFunctions();
      const updateArticle = httpsCallable(functions, "updateArticle");
      const newArticle = httpsCallable(functions, "newArticle");

      if (val.uid) {
        await updateArticle(val);
        dispatch("getNieuws");
      } else {
        await newArticle(val);
        dispatch("getNieuws");
      }

      commit("setSaving", false);
      alert("Artikel opgeslagen!");
    },
    async deleteArticle({ dispatch }, i) {
      let r = confirm("Weet je het zeker dat je dit artikel wilt verwijderen?");
      if (r) {
        await deleteDoc(doc(db, "nieuws", i.uid));
        // Laat de geüploade afbeelding niet als los bestand achter.
        await deleteImageByUrl(i.header_image);
        alert("Artikel verwijderd!");
        dispatch("getNieuws");
      }
    },
  },
  modules: {},
});
